import { render } from "./LayoutDrop.vue?vue&type=template&id=65a98266"
import script from "./LayoutDrop.vue?vue&type=script&lang=js"
export * from "./LayoutDrop.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__